/**
 * 将钱包 / RPC 抛出的英文技术错误转成用户可读文案（中/英）。
 * 去掉 MetaMask 等附带的 JSON 尾巴，避免整段代码式提示。
 */
export function humanizeWalletError(raw, langCode = 'en') {
  const text = extractMessage(raw)
  const l = String(langCode || 'en').toLowerCase()
  const pick = (zh, en) => (l === 'zh' ? zh : en)

  const s = text.toLowerCase()
  if (!text.trim()) {
    return pick('操作失败，请稍后重试', 'Something went wrong. Please try again.')
  }

  if (
    /user denied|denied transaction|user rejected|rejected the request|rejected transaction|action_rejected|4001|cancelled|canceled|rejected signature/.test(
      s
    )
  ) {
    return pick('已在钱包关闭本次签名', 'You closed this step in your wallet. Try again whenever you like.')
  }

  if (/insufficient funds|insufficient balance for transaction|insufficient balance/.test(s)) {
    return pick('主网币余额不足，无法支付手续费', 'Insufficient native currency to pay network fees.')
  }

  if (/intrinsic gas too low|out of gas|gas required exceeds|exceeds block gas limit/.test(s)) {
    return pick('Gas 不足或 Gas 上限过低', 'Gas is too low or the gas limit is insufficient.')
  }

  if (/nonce too low|nonce has already been used|nonce too high/.test(s)) {
    return pick('交易序号异常，请稍后再试', 'Invalid transaction nonce. Please wait a moment and try again.')
  }

  if (/replacement transaction underpriced|already known|already imported/.test(s)) {
    return pick('有待确认交易或重复提交，请稍后再试', 'A pending transaction may be blocking this one. Please wait and retry.')
  }

  if (/execution reverted|revert|vm exception/.test(s)) {
    return pick('合约执行未通过', 'The smart contract reverted this transaction.')
  }

  if (/network|timeout|timed out|failed to fetch|econnreset|socket hang up|could not detect network/.test(s)) {
    return pick('网络异常，请稍后重试', 'Network error. Please try again.')
  }

  let cleaned = text.replace(/\s*\{[\s\S]*$/, '').replace(/\bhttps?:\/\/\S+/gi, '').replace(/\s+/g, ' ').trim()
  if (cleaned.length > 140) cleaned = `${cleaned.slice(0, 137)}…`
  if (!cleaned) return pick('操作失败，请稍后重试', 'Something went wrong. Please try again.')
  return cleaned
}

function extractMessage(raw) {
  if (raw == null) return ''
  if (typeof raw === 'string') return raw
  if (typeof raw === 'object' && raw.message != null) return String(raw.message)
  try {
    return JSON.stringify(raw)
  } catch {
    return String(raw)
  }
}
